import { ArrowTopRightOnSquareIcon, ClipboardDocumentCheckIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import Button from './Button';
import CopyToClipboard from './CopyToClipboard';
import removeProtocolFromUrl from '../lib/removeProtocolFromUrl';

const ShareLink = ({ link, onVisit }) => {
  const defaultButtonText = 'Copy';
  const [buttonText, setButtonText] = useState(defaultButtonText);

  return (
    <div className="flex gap-4 px-4 w-full rounded border-1 border-gray-100 dark:border-border focus:shadow-none bg-gray-50 dark:bg-card py-3">
      <div className="flex min-w-0 items-center overflow-hidden font-medium text-gray-500 dark:text-muted-foreground">
        <a
          href={link}
          rel="noreferrer"
          target="_blank"
          className="truncate no-underline hover:text-gray-700 dark:hover:text-muted-foreground text-sm"
          onClick={onVisit}
        >
          {removeProtocolFromUrl(link)}
        </a>
      </div>

      <div className="ml-auto flex shrink-0 items-center gap-x-2">
        <Button
          className="h-10"
          to={link}
          target="_blank"
          appearance="light"
          variant="icon-button"
          size="small"
          onClick={onVisit}
        >
          <ArrowTopRightOnSquareIcon className="w-4 h-4 mx-1" />
        </Button>

        <CopyToClipboard
          text={link}
          onCopy={() => {
            setButtonText(
              <div className="flex gap-x-2 items-center">
                <ClipboardDocumentCheckIcon className="w-5 h-5" />
                Copied!
              </div>,
            );

            window.setTimeout(() => {
              setButtonText(defaultButtonText);
            }, 1000);
          }}
        >
          <Button appearance="primary">{buttonText}</Button>
        </CopyToClipboard>
      </div>
    </div>
  );
};

export default ShareLink;
